import React from 'react';
import Link from 'next/link';
import { H3, H4, P } from '../text';
import { LinkButton } from '../link-button';

interface IPageFooterCTAProps {
	text?: string | null;
	description?: string | null;
	link?: string | null;
	className?: string;
}

export const PageFooterCTA: React.FC<IPageFooterCTAProps> = ({ text, description, link, className = '' }) => {
	if (!text || !link) {
		return null;
	}

	return (
		<section className={`bg-gray-50 py-16 ${className}`}>
			<div className="container mx-auto px-4 max-w-7xl text-center">
				<div className="max-w-4xl mx-auto">
					<H3 className="mb-4">Word ook partner van de Keuken Kampioen Divisie</H3>
					{description && (
						<div className="mb-6 !text-2xl" dangerouslySetInnerHTML={{ __html: description }} />
					)}
					<LinkButton href={link} variant="primary">
						{text}
					</LinkButton>
				</div>
			</div>
		</section>
	);
};

export default PageFooterCTA;
